import {
  Box,
  type BoxProps,
  CircularProgress,
  type CircularProgressProps,
} from '@mui/material'
import { colorPrimitives } from 'components/Theme'

const ActivityIndicatorMeasures: Record<string, string> = {
  small: '25px',
  medium: '50px',
  big: '80px',
  fullPage: '80px',
}

const ActivityIndicatorColors: Record<string, string> = {
  red: colorPrimitives.redGaming,
  white: colorPrimitives.white,
}

export const ActivityIndicator = (
  props: BoxProps & {
    circularProgressProps?: CircularProgressProps
    size?: 'small' | 'medium' | 'big' | 'fullPage'
    color?: 'red' | 'white'
  }
) => {
  const {
    size = 'medium',
    color = 'red',
    circularProgressProps,
    ...boxProps
  } = props

  return (
    <Box
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      flex="1"
      height={size === 'fullPage' ? '100vh' : 'auto'}
      {...boxProps}
    >
      <CircularProgress
        {...circularProgressProps}
        size={ActivityIndicatorMeasures[size]}
        sx={{ color: ActivityIndicatorColors[color] }}
      />
    </Box>
  )
}
